import styled from "styled-components";
import Color from "../../assets/color";

const InputNumberStyled = styled.div`
  .btn-qty {
    width: 25px !important;
    height: 25px;
    border-radius: 100%;
  }

  .btn-minus {
    background-color: ${Color.athensGrey};
    border: none;
  }

  .option-list {
    .btn-qty {
      background-color: ${Color.athens};
      border: none;
    }
  }

  .cart-qty {
    .btn-qty {
      width: 15px !important;
      height: 15px;
      background-color: ${Color.athens};
      border: none;
    }
  }
`;

export default InputNumberStyled;
